import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { endpoints } from './../../../environments/environment';
import {
	LimiteGlobalRetorno,
	LimiteGlobalStatus,
} from './models/limite-global';

@Injectable()
export class LimiteGlobalService {
	private namedStarage = 'ST_MODAL_LG';

	public refreshLG = new BehaviorSubject<boolean>(true);

	constructor(private http: HttpClient) {}

	public setRefreshLG(): void {
		this.refreshLG.next(true);
	}

	public getGlobalLimitStatus(): Observable<LimiteGlobalStatus> {
		return this.http.get<LimiteGlobalStatus>(
			`${endpoints.accounts.limiteGlobal}/situacao-conta`
		);
	}

	public getGlobalLimitConsulta(): Observable<LimiteGlobalRetorno> {
		return this.http.get<LimiteGlobalRetorno>(
			`${endpoints.accounts.limiteGlobal}/consulta`
		);
	}

	public atualizaLimiteCredito(LimiteCredito: number): Observable<any> {
		return this.http.post<any>(
			`${endpoints.accounts.limiteGlobal}/atualizar-limite-credito`,
			{ CreditCard: { LimiteCredito } }
		);
	}

	public setRouteredByModal(): void {
		localStorage.setItem(this.namedStarage, '1');
	}

	public get canShowModal(): boolean {
		return !localStorage.getItem(this.namedStarage);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limite-global/limite-global.service.ts